__turbopack_context__.v({
  "activeFilter": "projects-module__QCVL6G__activeFilter",
  "card": "projects-module__QCVL6G__card",
  "category": "projects-module__QCVL6G__category",
  "clearButton": "projects-module__QCVL6G__clearButton",
  "container": "projects-module__QCVL6G__container",
  "content": "projects-module__QCVL6G__content",
  "controls": "projects-module__QCVL6G__controls",
  "filterButton": "projects-module__QCVL6G__filterButton",
  "filterGroup": "projects-module__QCVL6G__filterGroup",
  "grid": "projects-module__QCVL6G__grid",
  "header": "projects-module__QCVL6G__header",
  "headingTitle": "projects-module__QCVL6G__headingTitle",
  "hero": "projects-module__QCVL6G__hero",
  "heroSubtitle": "projects-module__QCVL6G__heroSubtitle",
  "heroTitle": "projects-module__QCVL6G__heroTitle",
  "image": "projects-module__QCVL6G__image",
  "imageWrapper": "projects-module__QCVL6G__imageWrapper",
  "location": "projects-module__QCVL6G__location",
  "meta": "projects-module__QCVL6G__meta",
  "noResults": "projects-module__QCVL6G__noResults",
  "overlay": "projects-module__QCVL6G__overlay",
  "pageButton": "projects-module__QCVL6G__pageButton",
  "pagination": "projects-module__QCVL6G__pagination",
  "projectCard": "projects-module__QCVL6G__projectCard",
  "projectCategory": "projects-module__QCVL6G__projectCategory",
  "projectTitle": "projects-module__QCVL6G__projectTitle",
  "projects": "projects-module__QCVL6G__projects",
  "projectsPage": "projects-module__QCVL6G__projectsPage",
  "readMore": "projects-module__QCVL6G__readMore",
  "searchGroup": "projects-module__QCVL6G__searchGroup",
  "searchInput": "projects-module__QCVL6G__searchInput",
  "sectionTitle": "projects-module__QCVL6G__sectionTitle",
  "sortSelect": "projects-module__QCVL6G__sortSelect",
  "subtitle": "projects-module__QCVL6G__subtitle",
  "title": "projects-module__QCVL6G__title",
  "uniformGrid": "projects-module__QCVL6G__uniformGrid",
  "viewAll": "projects-module__QCVL6G__viewAll",
});
